import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/wrapper.vue');

import adminsRoutes from '@/modules/admins/admins-inspection.routes';
import authRoutes from '@/modules/auth/auth-inspection.routes';
import branchesRoutes from '@/modules/branches/branches-inspection.routes';
import brandsRoutes from '@/modules/brands/brands-inspection.routes';
import carBodyTypesRoutes from '@/modules/carBodyTypes/carBodyTypes-inspection.routes';
import carClassesRoutes from '@/modules/carClasses/carClasses-inspection.routes';
import carModelsRoutes from '@/modules/carModels/carModels-inspection.routes';
import carOptionsRoutes from '@/modules/carOptions/carOptions-inspection.routes';
import countriesRoutes from '@/modules/countries/countries-inspection.routes';
import dashboardRoutes from '@/modules/dashboard/dashboard-inspection.routes';
import inspectionPackagesRoutes from '@/modules/inspectionPackages/inspectionPackages.routes';
import packagesRoutes from '@/modules/packages/packages-inspection.routes';
import packageSubscriptionsRoutes from '@/modules/packageSubscriptions/packageSubscriptions-inspection.routes';
import promotionsRoutes from '@/modules/promotions/promotions-inspection.routes';
import rolesRoutes from '@/modules/roles/roles-inspection.routes';
import structuresRoutes from '@/modules/structures/structures-inspection.routes';
import financialRoutes from '@/modules/financial/financial.routes';
import vinReportsRoutes from '@/modules/vinReports/vinReports-inspection.routes';

export default [
  {
    path: '',
    component: Layout,
    meta: { prefix: PREFIX.INSPECTOR },
    children: [
      ...adminsRoutes,
      ...authRoutes,
      ...branchesRoutes,
      ...brandsRoutes,
      ...carBodyTypesRoutes,
      ...carClassesRoutes,
      ...carModelsRoutes,
      ...carOptionsRoutes,
      ...countriesRoutes,
      ...dashboardRoutes,
      ...inspectionPackagesRoutes,
      ...packagesRoutes,
      ...packageSubscriptionsRoutes,
      ...promotionsRoutes,
      ...rolesRoutes,
      ...structuresRoutes,
      ...financialRoutes,
      ...vinReportsRoutes,
    ],
  },
];
